import { StoreData, getDimensionName } from '../getPageContext'

export const buildDimensionComparisonContent = (
  data?: StoreData
): Record<string, unknown> => {
  if (!data?.dimensionsComparison) return {}

  const { dimensionsComparison, milestones, locale } = data

  const dimensionTrends = dimensionsComparison.map((item) => ({
    snapshot: item.snapshot,
    dimensions: {
      [getDimensionName(1, undefined, locale)]:
        Math.round(item.dimension1 * 10) / 10,
      [getDimensionName(2, undefined, locale)]:
        Math.round(item.dimension2 * 10) / 10,
      [getDimensionName(3, undefined, locale)]:
        Math.round(item.dimension3 * 10) / 10,
      [getDimensionName(4, undefined, locale)]:
        Math.round(item.dimension4 * 10) / 10,
      [getDimensionName(5, undefined, locale)]:
        Math.round(item.dimension5 * 10) / 10,
    },
  }))

  const formattedMilestones = (milestones ?? []).map((m) => {
    const dateObject = new Date(parseInt(String(m.date), 10))
    const dateStr = isNaN(dateObject.getTime())
      ? m.date
      : dateObject.toISOString().split('T')[0]
    return { title: m.title, date: dateStr }
  })

  return {
    dimensionTrends,
    milestones: formattedMilestones,
  }
}
